import {resources} from "../../../../core/models/resource/resources";
import {ArticleMarketplacePaths, ArticleMarketplaces} from "../types/marketplace.types";

export const wildberriesResourceType = resources['wildberries-product-cards'];
export const ozonResourceType = resources['ozon-products'];

export const defaultArticleMarketplaces: ArticleMarketplaces = {
  wildberries: [],
  ozon: []
}

export const articleMarketplacePaths: Array<ArticleMarketplacePaths> = [
  { key: 'wildberries', path: wildberriesResourceType.path },
  { key: 'ozon', path: ozonResourceType.path }
];

export const marketplaceTypes = {
  [wildberriesResourceType.path]: 'wildberries',
  [ozonResourceType.path]: 'ozon'
} as const;
